var _mask, _g, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSessionComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 144,
    height: 144
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 72,
    r: 72,
    fill: "#1FAF7C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 72,
    r: 72,
    fill: "#1FAF7C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6693 93.6602C57.6537 115.361 63.3911 126.614 68.6112 136.789L69.2895 138.111C70.4165 140.307 71.5287 142.47 72.6749 144.699C78.2414 155.522 92.0675 161.1 104.077 156.894C106.778 155.955 109.147 154.6 111.133 152.944L108.026 156.014C103.376 160.186 97.6951 163.575 91.1167 165.877C65.3794 174.872 35.321 163.778 22.8627 141.061L-12 72.9662L-11.9551 72.9443C-10.4959 72.2405 26.1887 55.0316 46.6693 93.6602ZM108.661 68C126.519 68 140.993 82.1126 140.993 99.5197C141.558 132.061 109.413 160.811 85.5449 151.475C106.388 140.762 105.272 131.851 105.084 130.894L105.07 130.83C105.067 130.816 105.065 130.809 105.065 130.809C88.9071 129.063 76.3319 115.739 76.3319 99.5197C76.3319 82.1126 90.8086 68 108.661 68Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.7501 41.4166H51.5834C49.4175 41.4166 47.3403 42.277 45.8087 43.8086C44.2772 45.3401 43.4167 47.4174 43.4167 49.5833V98.5833C43.4167 100.749 44.2772 102.826 45.8087 104.358C47.3403 105.89 49.4175 106.75 51.5834 106.75H92.4167C94.5827 106.75 96.6599 105.89 98.1915 104.358C99.723 102.826 100.583 100.749 100.583 98.5833V49.5833C100.583 47.4174 99.723 45.3401 98.1915 43.8086C96.6599 42.277 94.5827 41.4166 92.4167 41.4166H84.2501",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0833 33.25H67.9167C63.4063 33.25 59.75 36.9063 59.75 41.4167C59.75 45.927 63.4063 49.5833 67.9167 49.5833H76.0833C80.5937 49.5833 84.25 45.927 84.25 41.4167C84.25 36.9063 80.5937 33.25 76.0833 33.25Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.75 78.1667L67.9167 86.3333L84.25 70",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionComplete);
export default __webpack_public_path__ + "static/media/session-complete.3ad73c06c942d460301f5cc8a2930814.svg";
export { ForwardRef as ReactComponent };